import { Stack } from "@mui/material";

import FilterExchange from "./FilterExchange";
import FilterName from "./FilterName";
import FilterType from "./FilterType";

// ----------------------------------------------------------------------

export const HeaderFilters = () => {
	return (
		<Stack flexDirection={"row"} alignItems={"center"} sx={{ px: 3, pb: 3 }} gap={3}>
			<FilterType />
			<FilterName />
			<FilterExchange />
		</Stack>
	);
};

export default HeaderFilters;
